import React from 'react';

import { Title } from '@components/Title';
import { TextBlock } from '@components/TextBlock';
import { AnimatedLink } from '@components/AnimatedLink';

import { mainInfo } from '@consts';

import {
  DividingLine,
  UInfoTitleBox,
  UInfoContainer,
  UILinkContainer,
  UInfoDescriptionBox,
} from './UniversityInfo.styled';
import { UniversityInfoProps } from './UneversityInfo.types';

export const UniversityInfo = ({
  customTitleColor,
  customTextColor,
}: UniversityInfoProps) => (
  <UInfoContainer>
    <UInfoTitleBox>
      <Title
        size={4}
        color={customTitleColor}
        text={mainInfo.EDUCATION_INFO.title}
        align="left"
      />
      <Title
        text={mainInfo.EDUCATION_INFO.location}
        font="SignikaLight"
        color={customTitleColor}
        size={3}
        align="left"
      />
    </UInfoTitleBox>
    <DividingLine borderColor={customTextColor} />
    <UInfoDescriptionBox>
      <TextBlock
        text={mainInfo.EDUCATION_INFO.description}
        align="left"
        indent={30}
        color={customTextColor}
      />
    </UInfoDescriptionBox>
    <UILinkContainer>
      <AnimatedLink link={mainInfo.EDUCATION_INFO.link} />
    </UILinkContainer>
  </UInfoContainer>
);
